// extracted by mini-css-extract-plugin
module.exports = {"th":"ActionsList_th__3xqOQ","edit":"ActionsList_edit__2wxY2","table":"ActionsList_table__2B4vQ","select":"ActionsList_select__1NeRu"};